import { Base } from '@studiometa/js-toolkit';
import Cookies from 'js-cookie';

/**
 * Panel Class.
 */
export default class Evin extends Base {
  isOpen = false;

  static config = {
    name: 'Evin',
    refs: ['close'],
  };

  /**
   *
   */
  mounted() {
    document.body.classList.add('overflow-hidden');
  }

  /**
   * Close on click
   * @returns {void}
   */
  onCloseClick() {
    Cookies.set('age_verified', '1', { expires: 30 });
    this.close();
  }

  /**
   * Show Popin
   * @returns {void}
   */
  open() {
    this.isOpen = true;
    this.$el.classList.remove('pointer-events-none');
  }

  /**
   * Close popin
   * @returns {void}
   */
  close() {
    this.isOpen = false;
    document.body.classList.remove('overflow-hidden');
    this.$el.classList.add('opacity-0', 'pointer-events-none');
  }
}
